import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-column p-0" }
const _hoisted_2 = { class: "flex-grow-1 card-p pb-0" }
const _hoisted_3 = { class: "d-flex flex-stack flex-wrap" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "text-dark text-hover-primary fw-bolder fs-3"
  }, "Generate Reports"),
  /*#__PURE__*/_createVNode("div", { class: "text-muted fs-7 fw-bold" }, " Finance and accounting reports ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createBlock("div", {
    class: [_ctx.widgetClasses, "card"]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", {
            class: [`text-${_ctx.chartColor}`, "fw-bolder fs-3"]
          }, " $24,500 ", 2)
        ])
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-7-chart card-rounded-bottom",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "area",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}